import { Login } from "../model/login.model";

export interface LoginState{
    Login: Login[];
}

export const initialState: LoginState = {
   Login: []
}
